import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import HomePage from './pages/HomePage'
import TokenPage from './pages/TokenPage'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="token" element={<TokenPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App
